import ScrollReveal from "../../../components/feature/ScrollReveal";
import { messageData } from "../../../mocks/companyData";

export default function MessageSection() {
  return (
    <section className="py-20 md:py-28 bg-airdoa-white">
      <div className="px-4 md:px-8 lg:px-12">
        <div className="max-w-4xl mx-auto">
          <ScrollReveal direction="up">
            <div className="text-center mb-14">
              <p className="section-label mb-3">{messageData.label}</p>
              <h2 className="section-title">{messageData.title}</h2>
            </div>
          </ScrollReveal>

          <ScrollReveal direction="up" delay={150}>
            <div className="bg-airdoa-cream rounded-lg p-8 md:p-12">
              <div className="mb-8 pb-6 border-b border-airdoa-gray-light/40">
                <p className="text-xs text-airdoa-gray mb-1">{messageData.role}</p>
                <p className="text-xl font-serif font-semibold text-airdoa-navy">
                  {messageData.name}
                </p>
              </div>

              <div className="flex flex-col gap-5">
                <p className="text-base md:text-lg font-serif font-medium text-airdoa-navy leading-[1.9]">
                  {messageData.greeting}
                </p>

                {messageData.paragraphs.map((paragraph, idx) => (
                  <p
                    key={idx}
                    className="text-sm md:text-base text-airdoa-gray leading-[2]"
                  >
                    {paragraph}
                  </p>
                ))}
              </div>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}